import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CompetitionProvider } from "./contexts/CompetitionContext";
import { Toaster } from "./components/ui/sonner";

// Public Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegistrationPage from "./pages/RegistrationPage";
import RegistrationSuccessPage from "./pages/RegistrationSuccessPage";
import PracticeZonePage from "./pages/PracticeZonePage";
import LobbyPage from "./pages/LobbyPage";
import MockQuizPage from "./pages/MockQuizPage";
import CompetitionPage from "./pages/CompetitionPage";
import ResultsPage from "./pages/ResultsPage";
import ParentPortalPage from "./pages/ParentPortalPage";
import CertificatePage from "./pages/CertificatePage";
import StickerPage from "./pages/StickerPage";
import VerifyCertPage from "./pages/VerifyCertPage";
import LiveLeaderboardPage from "./pages/LiveLeaderboardPage";

// Admin Pages
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboardHome from "./pages/admin/AdminDashboardHome";
import AdminCompetitionPage from "./pages/admin/AdminCompetitionPage";
import AdminParticipantsPage from "./pages/admin/AdminParticipantsPage";
import AdminQuestionsPage from "./pages/admin/AdminQuestionsPage";
import AdminResultsPage from "./pages/admin/AdminResultsPage";
import AdminArchivePage from "./pages/admin/AdminArchivePage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";

function App() {
  return (
    <AuthProvider>
      <CompetitionProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/admin/login" element={<LoginPage />} />
              <Route path="/registration" element={<RegistrationPage />} />
              <Route path="/registration/success" element={<RegistrationSuccessPage />} />
              <Route path="/registration/payment" element={<RegistrationPage />} />
              <Route path="/practice" element={<PracticeZonePage />} />
              <Route path="/lobby" element={<LobbyPage />} />
              <Route path="/mock-quiz" element={<MockQuizPage />} />
              <Route path="/competition" element={<CompetitionPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/parent" element={<ParentPortalPage />} />
              <Route path="/certificate" element={<CertificatePage />} />
              <Route path="/sticker" element={<StickerPage />} />
              <Route path="/verify-cert" element={<VerifyCertPage />} />
              <Route path="/live-leaderboard/:linkId" element={<LiveLeaderboardPage />} />

              {/* Admin Routes - Sidebar Layout */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboardHome />} />
                <Route path="competition" element={<AdminCompetitionPage />} />
                <Route path="participants" element={<AdminParticipantsPage />} />
                <Route path="questions" element={<AdminQuestionsPage />} />
                <Route path="results" element={<AdminResultsPage />} />
                <Route path="archive" element={<AdminArchivePage />} />
                <Route path="settings" element={<AdminSettingsPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster />
        </div>
      </CompetitionProvider>
    </AuthProvider>
  );
}

export default App;
